import React, { useState } from "react";
import { Link } from "react-router-dom";
import NoDataText from "../NoDataText";
import Pagination from "../Pagination/Pagination";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdOutlineLogout } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import SearchBarResults from "../Search/SearchBarResults";

const TopVouchers = (props) => {
  const {
    TableData,
    totalPageCount,
    setPageNumber,
    limit,
    handleSearchInput,
    handleKeypress,
    handleSearch,
    searchValue,
    HandleSortCol,
    flag,
  } = props;

  return (
    <>
      <div className="manage-vou-main pt-4 Blist">
        <p className="page-maintitle">Latest Vouchers Listed</p>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
            </InputGroup.Text>
            <Form.Control
              className="search_feild"
              value={searchValue}
              onChange={(e) => handleSearchInput(e)}
              onKeyPress={handleKeypress}
            />
            <Button variant="outline-secondary" onClick={handleSearch}>
              Search
            </Button>
          </InputGroup>
        </div>
      </div>
      <SearchBarResults SearchValue={searchValue} />
      <div class="table-responsive-xl black-header">
        <table class="recentact-table mt-3 table vou-list-Table">
          <thead>
            {/*  ["voucher_name","bi_name","voucher_value","download_count","redeemed_count"] */}
            <tr>
              <th onClick={() => HandleSortCol("voucher_name")}>
                <Button className="btn btn-primary sortIcon">
                  Voucher Name
                  {flag.voucher_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucher_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>

              <th onClick={() => HandleSortCol("bi_name")}>
                <Button className="btn btn-primary sortIcon ">
                  Business Name
                  {flag.business_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.business_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>

              <th onClick={() => HandleSortCol("voucher_value")}>
                <Button className="btn btn-primary sortIcon">
                  Voucher Value
                  {flag.voucher_value === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucher_value === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>

              <th onClick={() => HandleSortCol("download_count")}>
                <Button className="btn btn-primary sortIcon">
                  Vouchers Sold
                  {flag.download_count === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.download_count === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th onClick={() => HandleSortCol("redeemed_count")}>
                <Button className="btn btn-primary sortIcon">
                  Vouchers Redeemed
                  {flag.redeemed_count === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.redeemed_count === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {TableData.length != 0 ? (
              <>
                {TableData.map((i, k) => {
                  return (
                    <tr>
                      <td title={i["Voucher Name"]}>
                        <Link
                          className="vouname-blue"
                          to={`/vouchers/voucherDetails/${i.city_voucher_id}`}
                        >
                          {i["Voucher Name"]}
                        </Link>
                      </td>
                      {/* <td style={{textAlign:'left'}}>{i['Voucher Name']}</td> */}
                      <td>{i["Business Name"]}</td>
                      <td>${i["Voucher Value"]}</td>
                      <td>{i["Vouchers Sold"]}</td>
                      <td>{i["Vouchers Redeemed"]}</td>
                    </tr>
                  );
                })}{" "}
              </>
            ) : (
              <tr class="toggle-row">
                <td colspan="8">
                  <p class="noData">{NoDataText.ErrText}</p>{" "}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {TableData.length != 0 ? (
        <Pagination
          totalPageCount={totalPageCount}
          setPageNumber={setPageNumber}
          limit={limit}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default TopVouchers;
